import { DownOutlined, UpOutlined } from "@ant-design/icons";
import store from "../store";
import util from "../util";
import { useEffect, useState } from "preact/hooks";

export default function PageNavTools() {
  const [curPage, setCurPage] = useState(1);
  const [headerOffset, setHeaderOffset] = useState(80);

  useEffect(() => {
    window.addEventListener('scroll', setCurrentPage);
    $('.page-tools>div').on('click', () => {
      setTimeout(() => {
        setCurrentPage();
      }, 100);
    });
    setHeaderOffset(store.getState().isAdmin ? 104 : 80);
  })

  function getNumPages() {
    return $('.page').length;
  }

  function setCurrentPage() {
    const $pages = $('.page');
    const $firstPage = $('#page-1');
    const zoomfactor = store.getState().zoom / 100;
    let position = 0;
    let pageDist = 0;

    if (store.getState().isMobileVersion) {
      position = window.scrollX;
      pageDist = $firstPage.width()! * zoomfactor;
    } else {
      position = window.scrollY;
      pageDist = $firstPage.height()! * zoomfactor;
    }

    $pages.each(function () {
      const $this = $(this);
      if ($this !== undefined && $this.css('display') !== 'none') {
        let pageStart = null;
        let pageEnd = null;

        if (store.getState().isMobileVersion) {
          pageStart = $this.offset()!.left;
          pageEnd = pageStart + pageDist;
        } else {
          pageStart = $this.offset()!.top;
          pageEnd = pageStart + pageDist;
        }

        if (position + headerOffset >= pageStart && position + headerOffset <= pageEnd) {
          const pageNum = util.getPageNumber($this);
          setCurPage(pageNum);
          return false;
        }
      }
    });
  }

  function prevPage() {
    const $prev = $(`#page-${curPage - 1}`);
    if (store.getState().isMobileVersion) {
      const scrollLeft = $prev.offset()!.left;
      $(window).scrollLeft(scrollLeft + 5);
      $('body').animate({ scrollLeft }, 500);
    } else {
      const scrollTop = $prev.offset()!.top - headerOffset;
      $(window).scrollTop(scrollTop + 5);
      $('body').animate({ scrollTop }, 500);
    }
  }

  function nextPage() {
    const $next = $(`#page-${curPage + 1}`);
    if (store.getState().isMobileVersion) {
      const scrollLeft = $next.offset()!.left;
      $(window).scrollLeft(scrollLeft + 5);
      $('body').animate({ scrollLeft }, 500);
    } else {
      const scrollTop = $next.offset()!.top - headerOffset;
      $(window).scrollTop(scrollTop + 5);
      $('body').animate({ scrollTop }, 500);
    }
  }

  const numPages = getNumPages();
  return (
    <div className="page-tools page-nav-tools">
      <div id="pageNavUp" className={`btn ly-gd-bt hint--left ${curPage === 1 ? 'disabled' : ''}`} data-hint="Previous Page" onClick={() => prevPage()}>
        <UpOutlined />
      </div>
      <span>Page</span>
      <span>{curPage}{numPages < 10 && <>&nbsp;</>}/{numPages < 10 && <>&nbsp;</>}{numPages}</span>
      <div id="pageNavDown" className={`btn ly-gd-bt hint--left ${curPage === numPages ? 'disabled' : ''}`} data-hint="Next Page" onClick={() => nextPage()}>
        <DownOutlined />
      </div>
    </div>
  )
}